import React, { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { api, inr, dt } from './adminApi';

export const AdminCustomers = ({ onSearchOrders }) => {
  const [q, setQ] = useState('');
  const [d, setD] = useState({ total: 0, repeat: 0, customers: [] });
  useEffect(() => { const t = setTimeout(() => api.customers(q).then(setD), 250); return () => clearTimeout(t); }, [q]);
  return (
    <div className="space-y-4" data-testid="admin-customers">
      <div className="flex flex-wrap items-center gap-3">
        <label className="relative">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--si-grey)]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, email, phone" className="si-input !w-72 !py-2 !pl-9" data-testid="customers-search" />
        </label>
        <p className="text-sm" data-testid="customers-summary"><b>{d.total}</b> buyers · <b className="text-[#7E22CE]">{d.repeat}</b> repeat buyers</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[760px]" data-testid="customers-table">
          <thead><tr className="border-b border-[var(--si-line)] text-left text-xs uppercase tracking-wider text-[var(--si-grey)]">
            <th className="py-2">Customer</th><th>Phone</th><th>City</th><th>Orders</th><th>Units</th><th>Total spent</th><th>Last order</th><th></th></tr></thead>
          <tbody>
            {d.customers.map((c) => (
              <tr key={c.email} className="border-b border-[var(--si-line)]" data-testid={`customer-row-${c.email}`}>
                <td className="py-2.5"><b>{c.name}</b> {c.repeat && <span className="ml-1 bg-[#F3E8FF] text-[#7E22CE] text-[10px] font-bold px-1.5 py-0.5 rounded">REPEAT</span>}<br /><span className="text-xs text-[var(--si-grey)]">{c.email}</span></td>
                <td>{c.phone}</td><td>{c.city}</td><td className="font-bold">{c.orders}</td><td>{c.units}</td>
                <td className="font-bold">{inr(c.spent)}</td><td className="text-xs">{dt(c.last_order)}</td>
                <td><button onClick={() => onSearchOrders(c.email)} className="text-[var(--si-blue)] font-semibold" data-testid={`customer-orders-${c.email}`}>View orders</button></td>
              </tr>
            ))}
          </tbody>
        </table>
        {d.customers.length === 0 && <p className="py-8 text-center text-[var(--si-grey)]">No paying customers yet.</p>}
      </div>
    </div>
  );
};

export default AdminCustomers;
